import React from 'react';
import { DashboardCard } from './DashboardCard';
import { BadgeIcon, WifiIcon, SignalIcon, GlobeIcon, BarChart4Icon, PieChartIcon, ZapIcon, BatteryFullIcon, SettingsIcon, InfoIcon } from 'lucide-react';
export function SubscriptionOverview() {
  // Mock data
  const subscriptionData = {
    active: 991,
    inactive: 348,
    pending: 80,
    total: 1419
  };
  const subscriptionTypes = [{
    name: 'iCRcell',
    active: 932,
    inactive: 244,
    total: 1176
  }, {
    name: 'iTRACKcell',
    active: 65,
    inactive: 0,
    total: 65
  }, {
    name: 'iCRwl',
    active: 357,
    inactive: 0,
    total: 357
  }, {
    name: 'iCPUMPv1',
    active: 4,
    inactive: 0,
    total: 4
  }, {
    name: 'iCPUMP',
    active: 10,
    inactive: 0,
    total: 10
  }];
  const regionSubscriptions = [{
    name: 'Aisco MENA',
    active: 10,
    inactive: 5,
    total: 15
  }, {
    name: 'Aisco AFRICA',
    active: 20,
    inactive: 8,
    total: 28
  }, {
    name: 'Aisco EUROPE',
    active: 820,
    inactive: 250,
    total: 1070
  }, {
    name: 'Aisco AMERICA',
    active: 180,
    inactive: 95,
    total: 275
  }, {
    name: 'Aisco LATAM',
    active: 160,
    inactive: 90,
    total: 250
  }, {
    name: 'Aisco ANZ',
    active: 150,
    inactive: 85,
    total: 235
  }];
  return <div className="space-y-6" data-id="element-2013">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2014">
        <DashboardCard icon={<BadgeIcon size={20} className="text-blue-400" data-id="element-2016" />} title="Subscription Summary" data-id="element-2015">
          <div className="flex flex-col" data-id="element-2017">
            <div className="flex justify-between items-start mb-6" data-id="element-2018">
              <div data-id="element-2019">
                <div className="text-5xl font-bold text-white" data-id="element-2020">
                  {subscriptionData.total}
                </div>
                <div className="text-sm text-blue-300 mt-2" data-id="element-2021">
                  Total Subscriptions
                </div>
              </div>
              <div className="flex items-center space-x-4" data-id="element-2022">
                <div className="flex items-center" data-id="element-2023">
                  <div className="w-3 h-3 rounded-full bg-blue-500 mr-1" data-id="element-2024"></div>
                  <span className="text-sm text-blue-300" data-id="element-2025">Active</span>
                </div>
                <div className="flex items-center" data-id="element-2026">
                  <div className="w-3 h-3 rounded-full bg-slate-600 mr-1" data-id="element-2027"></div>
                  <span className="text-sm text-blue-300" data-id="element-2028">Inactive</span>
                </div>
              </div>
            </div>
            <div className="relative h-48" data-id="element-2029">
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-2030">
                <div className="relative w-40 h-40" data-id="element-2031">
                  <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-2032">
                    <circle cx="50" cy="50" r="40" fill="transparent" stroke="#334155" strokeWidth="15" data-id="element-2033" />
                    <circle cx="50" cy="50" r="40" fill="transparent" stroke="#3b82f6" strokeWidth="15" strokeDasharray={`${subscriptionData.active / subscriptionData.total * 251.2} 251.2`} transform="rotate(-90 50 50)" data-id="element-2034" />
                  </svg>
                  <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-2035">
                    <div className="text-3xl font-bold text-white" data-id="element-2036">
                      {subscriptionData.active}
                    </div>
                    <div className="text-sm text-blue-300" data-id="element-2037">active</div>
                  </div>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 text-lg text-blue-300" data-id="element-2038">
                <div className="flex items-center" data-id="element-2039">
                  <div className="w-3 h-3 rounded-full bg-slate-600 mr-1" data-id="element-2040"></div>
                  <span data-id="element-2041">{subscriptionData.inactive}</span>
                </div>
              </div>
              <div className="absolute bottom-0 right-0 text-lg text-blue-300" data-id="element-2042">
                <div className="flex items-center" data-id="element-2043">
                  <div className="w-3 h-3 rounded-full bg-amber-500 mr-1" data-id="element-2044"></div>
                  <span data-id="element-2045">{subscriptionData.pending}</span>
                </div>
              </div>
            </div>
          </div>
        </DashboardCard>
        <DashboardCard icon={<WifiIcon size={20} className="text-blue-400" data-id="element-2047" />} title="Subscription Types" data-id="element-2046">
          <div className="space-y-6" data-id="element-2048">
            {subscriptionTypes.map((type, index) => <div key={index} className="space-y-2" data-id="element-2049">
                <div className="flex justify-between items-center" data-id="element-2050">
                  <div className="text-lg font-medium text-white" data-id="element-2051">
                    {type.name}
                  </div>
                  <div className="text-sm text-blue-300" data-id="element-2052">
                    {type.active} active
                    {type.inactive > 0 ? ` / ${type.inactive} inactive` : ''}
                  </div>
                </div>
                <div className="w-full bg-slate-700/50 rounded-full h-2.5 overflow-hidden" data-id="element-2053">
                  <div className="bg-blue-500 h-2.5 rounded-full" style={{
                width: `${type.active / 1000 * 100}%`
              }} data-id="element-2054"></div>
                </div>
                <div className="text-xs text-blue-300 text-right" data-id="element-2055">
                  {type.active} of {type.total}
                </div>
              </div>)}
          </div>
        </DashboardCard>
      </div>
      <DashboardCard icon={<GlobeIcon size={20} className="text-blue-400" data-id="element-2057" />} title="Regional Distribution" data-id="element-2056">
        <div className="flex justify-end mb-6" data-id="element-2058">
          <div className="flex items-center space-x-4" data-id="element-2059">
            <div className="flex items-center" data-id="element-2060">
              <div className="w-3 h-3 rounded-full bg-blue-500 mr-1" data-id="element-2061"></div>
              <span className="text-sm text-blue-300" data-id="element-2062">Active</span>
            </div>
            <div className="flex items-center" data-id="element-2063">
              <div className="w-3 h-3 rounded-full bg-slate-600 mr-1" data-id="element-2064"></div>
              <span className="text-sm text-blue-300" data-id="element-2065">Inactive</span>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2066">
          {regionSubscriptions.map((region, index) => <div key={index} className="bg-slate-800/50 rounded-lg p-4" data-id="element-2067">
              <div className="flex justify-between items-center mb-3" data-id="element-2068">
                <div className="text-lg font-medium text-white" data-id="element-2069">
                  {region.name}
                </div>
                <div className="text-sm text-blue-300" data-id="element-2070">{region.total}</div>
              </div>
              <div className="space-y-2" data-id="element-2071">
                <div className="flex justify-between items-center" data-id="element-2072">
                  <span className="text-xs text-blue-300" data-id="element-2073">Active</span>
                  <span className="text-xs text-white" data-id="element-2074">{region.active}</span>
                </div>
                <div className="w-full bg-slate-700/50 rounded-full h-1.5 overflow-hidden" data-id="element-2075">
                  <div className="bg-blue-500 h-1.5 rounded-full" style={{
                width: `${region.active / region.total * 100}%`
              }} data-id="element-2076"></div>
                </div>
                <div className="flex justify-between items-center" data-id="element-2077">
                  <span className="text-xs text-blue-300" data-id="element-2078">Inactive</span>
                  <span className="text-xs text-white" data-id="element-2079">{region.inactive}</span>
                </div>
                <div className="w-full bg-slate-700/50 rounded-full h-1.5 overflow-hidden" data-id="element-2080">
                  <div className="bg-slate-600 h-1.5 rounded-full" style={{
                width: `${region.inactive / region.total * 100}%`
              }} data-id="element-2081"></div>
                </div>
              </div>
            </div>)}
        </div>
      </DashboardCard>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2082">
        <DashboardCard icon={<SettingsIcon size={20} className="text-blue-400" data-id="element-2084" />} title="Subscription Map" data-id="element-2083">
          <div className="relative h-80 bg-slate-900 rounded-lg overflow-hidden flex items-center justify-center" data-id="element-2085">
            <div className="text-blue-400 text-lg" data-id="element-2086">
              Map visualization will be displayed here
            </div>
          </div>
        </DashboardCard>
        <DashboardCard icon={<ZapIcon size={20} className="text-blue-400" data-id="element-2088" />} title="Subscription Status" data-id="element-2087">
          <div className="space-y-6" data-id="element-2089">
            <div className="flex justify-center" data-id="element-2090">
              <div className="relative w-40 h-40" data-id="element-2091">
                <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-2092">
                  <circle cx="50" cy="50" r="40" fill="transparent" stroke="#0c4a6e" strokeWidth="15" data-id="element-2093" />
                  <circle cx="50" cy="50" r="40" fill="transparent" stroke="#22d3ee" strokeWidth="15" strokeDasharray="251.2 251.2" strokeDashoffset="230" transform="rotate(-90 50 50)" data-id="element-2094" />
                </svg>
                <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-2095">
                  <div className="text-5xl font-bold text-cyan-300" data-id="element-2096">1</div>
                  <div className="text-sm text-blue-300" data-id="element-2097">Pending</div>
                </div>
              </div>
            </div>
            <div className="bg-slate-800/50 rounded-lg p-4" data-id="element-2098">
              <div className="text-lg font-medium text-white mb-3" data-id="element-2099">
                Premium Subscriptions
              </div>
              <div className="space-y-4" data-id="element-2100">
                <div className="space-y-2" data-id="element-2101">
                  <div className="flex justify-between items-center" data-id="element-2102">
                    <span className="text-sm text-blue-300" data-id="element-2103">iCRcell</span>
                    <span className="text-sm text-white" data-id="element-2104">688 active</span>
                  </div>
                  <div className="w-full bg-slate-700/50 rounded-full h-2 overflow-hidden" data-id="element-2105">
                    <div className="bg-blue-500 h-2 rounded-full" style={{
                    width: '70%'
                  }} data-id="element-2106"></div>
                  </div>
                  <div className="text-xs text-blue-300 text-right" data-id="element-2107">
                    688 active / 244 inactive
                  </div>
                </div>
                <div className="space-y-2" data-id="element-2108">
                  <div className="flex justify-between items-center" data-id="element-2109">
                    <span className="text-sm text-blue-300" data-id="element-2110">iCRwl</span>
                    <span className="text-sm text-white" data-id="element-2111">357 active</span>
                  </div>
                  <div className="w-full bg-slate-700/50 rounded-full h-2 overflow-hidden" data-id="element-2112">
                    <div className="bg-cyan-500 h-2 rounded-full" style={{
                    width: '35%'
                  }} data-id="element-2113"></div>
                  </div>
                  <div className="text-xs text-blue-300 text-right" data-id="element-2114">
                    357 active / 0 inactive
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DashboardCard>
      </div>
    </div>;
}